var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatarea"},[_c('Body',{attrs:{"steps":_vm.steps,"conversation":_vm.getConversation}}),(_vm.getConversation.length != 0)?_c('div',{staticClass:"promptPolicyContainer"},[_c('Prompt')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }